module.exports = __webpack_public_path__ + "static/media/ADD2.8b970b8b.svg";